import PropTypes from "prop-types"
import React, { Component } from "react"
import Form from "semantic-ui-react/dist/es/collections/Form/Form"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Button from "semantic-ui-react/dist/es/elements/Button/Button"
import Header from "semantic-ui-react/dist/es/elements/Header/Header"
import Modal from "semantic-ui-react/dist/es/modules/Modal/Modal"
import "./ConfirmModal.css"
import TextVerification from "./TextVerification"

class ConfirmModal extends Component {
  state = {
    modalOpen: false,
    done: false,
    isPending: false,
    error: null,
    disableButton: !!this.props.verification
  }

  onOpen = e =>
    this.setState({
      modalOpen: true
    })

  onClose = e =>
    this.setState({
      modalOpen: false
    })

  onConfirm = e => {
    this.setState({
      isPending: true
    })
    this.setState(
      {
        done: true,
        isPending: false
      },
      async () => {
        const result = await this.props.onConfirm()
        if (result.error) {
          this.setState({ error: result.error })
        }
      }
    )
  }

  onCancel = e => {
    this.setState({
      modalOpen: false
    })
  }

  render() {
    let { buttonLabel, header, description, verification } = this.props
    if (this.state.done) {
      if (this.state.error) {
        return this.props.failure(this.state.error)
      } else {
        return this.props.success
      }
    }
    return (
      <Modal
        trigger={
          <Button basic type="button" color="red" onClick={this.onOpen}>
            {buttonLabel}
          </Button>
        }
        open={this.state.modalOpen}
        onClose={this.onClose}
        className="ConfirmModal"
      >
        <Modal.Content>
          <Form loading={this.state.isPending}>
            <Header as="h1" style={{ marginBottom: ".5em", fontWeight: "300" }}>
              {header}
            </Header>
            {verification && (
              <TextVerification
                verification={verification}
                report={match => this.setState({ disableButton: !match })}
              />
            )}
            <div>{description}</div>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Grid>
            <Grid.Row columns="2">
              <Grid.Column>
                <Button
                  onClick={this.onCancel}
                  fluid
                  color="blue"
                  content="Cancel"
                  inverted
                  type="button"
                  disabled={this.state.isPending}
                />
              </Grid.Column>
              <Grid.Column>
                <Button
                  onClick={this.onConfirm}
                  fluid
                  content={buttonLabel}
                  color="red"
                  type="button"
                  disabled={this.state.isPending || this.state.disableButton}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Actions>
      </Modal>
    )
  }
}

ConfirmModal.propTypes = {
  buttonLabel: PropTypes.string,
  header: PropTypes.string,
  description: PropTypes.node,
  onConfirm: PropTypes.func.isRequired,
  success: PropTypes.node.isRequired,
  verification: PropTypes.shape({
    prompt: PropTypes.node.isRequired,
    text: PropTypes.string.isRequired
  })
}

ConfirmModal.defaultProps = {
  buttonLabel: "Continue",
  header: "Are You Sure?",
  description: ""
}

export default ConfirmModal
